import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { canonicalProductUrl } from "../utils/siteDomains";

export default function SiteDomainBoundary({ children }) {
  const location = useLocation();
  const target = typeof window === "undefined" ? null : canonicalProductUrl(
    `${window.location.origin}${location.pathname}${location.search}${location.hash}`,
  );

  useLayoutEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  return target ? null : children;
}
